import type { INorm } from "@/shared/services/norms/norms-http.service";

export function findNormMatchingTemplateName(templateName: string | undefined, norms: INorm[]): INorm | undefined {
  if (!templateName) return undefined;
  const normalized = templateName.toLowerCase().trim();
  if (!normalized) return undefined;
  return norms.find((norm) => norm.name.toLowerCase().trim() === normalized);
}
